'use client';

import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import React, { useEffect, useState } from 'react';
import PostAuthorProfile from './PostAuthorProfile';
import PostImage from './PostImage';
import PostVideo from './PostVideo';
import Typography from '@ui/Typography';
import ReactionBar from './ReactionBar';
import ActionBar from './ActionBar';
import PostMessage from './PostMessage';
import NonProfitCauses from './NonProfitCauses';
import {
  getPostImage,
  getPostLink,
  shouldDisablePostCauses,
} from '@utils/post.helper';
import { isArray, size } from 'lodash-es';
import Link from '@ui/Link';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import PostImageLink from './PostImageLink';

function CelebrationPostBody(props) {
  const { post, type, home, orgSlug = null } = props;

  const { sourcePostData } = post;
  const nonProfit = post.renderProps.nonProfit;
  const recipients = post.sourcePostData?.recipients;

  const renderRecipients = () => {
    return recipients.map((recipient) => {
      const slug = recipient.slug ? `/${recipient.slug}` : undefined;
      if (slug) {
        return `<a href="${slug}" class="text-14 no-underline font-medium hover:text-text-hyperlink">${recipient.firstName} ${recipient.lastName}</a>`;
      } else {
        return `<a class="text-14 no-underline font-medium">${recipient.firstName} ${recipient.lastName}</a>`;
      }
    });
  };

  const messageWithMentions = `${renderRecipients()} ${
    post.sourcePostData.message
  }`;

  const hasCelebrationVideo =
    sourcePostData && sourcePostData.attachmentType === 'video';
  const hasVideo =
    post?.renderProps?.videoUrls &&
    isArray(post.renderProps.videoUrls) &&
    post.renderProps.videoUrls[0];

  const disablePostCauses = shouldDisablePostCauses(home, orgSlug);

  return (
    <TrackPostVisibility post={post} type={type}>
      <div className="flex flex-col">
        <div className="flex flex-col gap-4 p-6 lg:p-4">
          {!disablePostCauses && nonProfit && nonProfit.causes && (
            <NonProfitCauses nonProfit={nonProfit} className="border-b pb-4" />
          )}
          <PostAuthorProfile
            post={post}
            home={home}
            orgSlug={orgSlug}
            className="border-b pb-4"
          />
          <div>
            <PostMessage message={messageWithMentions} />
          </div>
        </div>

        {hasCelebrationVideo || hasVideo ? (
          <PostVideo post={post} type="celebrate" />
        ) : (
            <PostImageLink post={post} />
        )}

        <div className="flex flex-col gap-6 px-6 pt-4 lg:px-4">
          <div className="divide-y border-t">
            <ReactionBar post={post} />

            <div className="flex justify-center py-2">
              <ActionBar post={post} orgSlug={orgSlug} />
            </div>
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default CelebrationPostBody;
